import React, { useState, useContext, ChangeEvent } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ResponseError, SubmitButton } from '@nintendo/forms';
import { useMsal } from '@azure/msal-react';
import { RoleUtils } from '@galaxy/lorule-react-commons';
import NinModal from './NinModal';
import ConfigContext from '../../../contexts/ConfigContext';
import { syncProject } from '../../../api/projectErrorApi';
import ModalConfirmCheckbox from './ModalConfirmCheckBox';

export interface SyncProjectModalProps {
    amId: number;
    toggleButton: JSX.Element;
    onSubmit?: () => void;
}

const SyncProjectModal = (props: SyncProjectModalProps) => {
    const { instance } = useMsal();
    const config = useContext(ConfigContext);
    const roles = RoleUtils.getRoles(instance);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [responseError, setResponseError] = useState('');

    const [enableSubmit, setEnableSubmit] = useState(false);

    const checkboxChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setEnableSubmit(event.target.checked);
    };

    return (
        <NinModal
            button={props.toggleButton}
            render={(toggleModal: () => void) => (
                <>
                    <Modal.Header closeButton>
                        <Modal.Title>Sync Project</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ResponseError errorMessage={responseError} />

                        <div>
                            Please confirm the issue has been corrected. Scheduling a
                            synchronization without correcting the original issue will cause the
                            error to reoccur.
                            <br />
                            <br />
                            The synchronization may take several minutes to complete in the
                            background.
                        </div>
                        <div>
                            <br />
                            <ModalConfirmCheckbox
                                label="  I have corrected the issue."
                                onChangeCallback={checkboxChanged}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="outline-secondary"
                            onClick={toggleModal}
                            disabled={isSubmitting}
                        >
                            Close
                        </Button>
                        <SubmitButton
                            className="btn-primary ml-auto"
                            disabled={!enableSubmit}
                            isSubmitting={isSubmitting}
                            buttonText="Schedule Synchronization"
                            onClick={async () => {
                                try {
                                    setIsSubmitting(true);
                                    await syncProject(
                                        config,
                                        props.amId,
                                        !RoleUtils.checkRole(roles, ['ActionMemo.Admin']),
                                    );
                                    toggleModal();
                                    if (props.onSubmit) {
                                        props.onSubmit();
                                    }
                                } catch (e) {
                                    if (e instanceof Error) {
                                        setResponseError(`Sync request failed: ${e.message}`);
                                    }
                                    setIsSubmitting(false);
                                }
                            }}
                        />
                    </Modal.Footer>
                </>
            )}
        />
    );
};

export default SyncProjectModal;
